export default ({ request }) => ({
  ecomAmzFtyPurchaseAddChangeApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/add/change',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeDetailsApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/details',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeRecordApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/record',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailChangeApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/change',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailDelChangeApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/del/change',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailChangeRecordApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/change/record',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailChangeRollbackApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/change/rollback',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeCancelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/cancel',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseChangeRejectApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/change/reject',
      method: 'POST',
      data,
    })
  },
})
